module.exports = __webpack_public_path__ + "img/foot_mail.b23713b9.png";